<div class="flex">
  <sbnb-subnav class="subnav__semi-reduced-padding">
    <sbnb-property-detail-subnav
      *ngIf="property$ | async as property"
      #propertyDetailSubnavComponent
      activeComponent="availability-rules"
      [onboardingStatus]="false"
      [propertyMuted]="property.muted"
      [bookingListing]="property.counts.booking > 0"
      [canManageAvailability]="property.can_manage_availability"
      (navChanged)="navChanged($event)"></sbnb-property-detail-subnav>
  </sbnb-subnav>
  <main class="subnav__exists flex-1" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div class="w-full">
      <app-feature-flag-tabs>
        <sbnb-page-header
          navTabs
          [parentPath]="'properties/segments/default'"
          class="block sbnbDesktop:hidden"></sbnb-page-header>
      </app-feature-flag-tabs>
      <div class="flex flex-col gap-3 mb-10">
        <div class="flex flex-col gap-2 md:flex-row md:justify-between md:items-center pb-4">
          <h2 class="nomargin nopadding">Availability Rules</h2>
          <ng-container *ngIf="property$ | async as property">
            <sbnb-property-select-dropdown
              class="flex-1 max-w-[400px]"
              *ngIf="properties$ | async as properties"
              [properties]="properties"
              [showPlaceholder]="false"
              [selectedPropertyId]="property.id"
              (selectedPropertyChanged)="propertyChanged($event)"></sbnb-property-select-dropdown>
          </ng-container>
        </div>
        <span>Manage your availability rules in Hospitable to control when your property can be booked.</span>
      </div>
    </div>
    <sbnb-helptext-wrapper [area]="'intro'" [pageId]="'property-availability-rules'"></sbnb-helptext-wrapper>
    <sbnb-loading-spinner *ngIf="loading$ | async" minHeight="250px"></sbnb-loading-spinner>
    <sbnb-property-availability-rules-form
      *ngIf="property$ | async as property"
      [property]="property"></sbnb-property-availability-rules-form>
  </main>
</div>

<sbnb-mobile-sidebar title="Availability rules">
  <sbnb-property-detail-subnav
    *ngIf="property$ | async as property"
    #propertyDetailSubnavComponent
    activeComponent="availability-rules"
    [onboardingStatus]="false"
    [propertyMuted]="property.muted"
    [bookingListing]="property.counts.booking > 0"
    [canManageAvailability]="property.can_manage_availability"
    (navChanged)="navChanged($event)"></sbnb-property-detail-subnav>
</sbnb-mobile-sidebar>
